import { render, staticRenderFns } from "./ChatPanelv2.vue?vue&type=template&id=2ad72bb2"
import script from "./ChatPanelv2.vue?vue&type=script&lang=js"
export * from "./ChatPanelv2.vue?vue&type=script&lang=js"
import style0 from "./ChatPanelv2.vue?vue&type=style&index=0&id=2ad72bb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports